import { Component, OnInit } from '@angular/core';
import { ErrorManagerService, HttpClientService } from '../../shared/';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiEndpoints } from '../constant';
import { User } from '../model';
import { CommonService } from '../../shared/services/common-service';
import { NgxCarousel } from 'ngx-carousel';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.css']
})
export class StaffComponent implements OnInit {
  public members: Array<User> = [];

  constructor(private httpClientService: HttpClientService,
    private ErrorManagerService: ErrorManagerService,
    private commonService: CommonService,
    private router: Router) { }
  public aboutUs: any;
  public arts = [


    {
      title : "වනයක අසිරි​ය",
      image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/jethya_sirisenage_1.jpg',
      name: "Jethya Sirisenage",
      school: "St.Mary's convent,Matara.",
      grade: "Grade 4"
    },
    // {
    //   title : "සම්බුදු  තෙමඟුල",
    //   image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/2020-06-15/2.jpg',
    //   name: "Divanshi Onaya",
    //   school: "Anula Vidyalaya",
    //   grade: "Grade 3"
    // },
    // {
    //   title : "අපේ පන්සල",
    //   image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/2020-06-15/3',
    //   name: "Kushalee Ovinya",
    //   school: "Anula Vidyalaya",
    //   grade: "Grade 5"
    // },
    {
      title : "මුවන්",
      image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/sumudu.jpg',
      name: "Sumudu Denuwan",
      school: "Nugawela",
      grade: "Grade 5"
    },
    // {
    //   title : "වෙසක් උත්සවය",
    //   image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/2020-05-07/12',
    //   name: "Kiruli Malinsa",
    //   school: "Wp/Jaya/Vidyakara B Vidyalaya",
    //   grade: "Grade 5"
    // },
    {
      title : "සැන්​දෑව​ක්",
      image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/jethya_sirisenage_2.jpg',
      name: "Jethya Sirisenage",
      school: "St.Mary's convent,Matara.",
      grade: "Grade 4"
    },
    {
      title : "Vidu",
      image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/sithika.jpg',
      name: "Sithika Kularatne",
      school: "St' Josseph's college",
      grade: "Grade 5"
    },
    {
      title : "මුහුදු පතුලේ සුන්දරත්වය",
      image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/sithika_2.jpg',
      name: "Sithika Kularatne",
      school: "St' Josseph's college",
      grade: "Grade 5"
    },
    {
      title : "උදෑසන අසිරිය",
      image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/yugeeth.jpg',
      name: "Yugeeth  Sandilu",
      school: "Ananda Sastralaya National school",
      grade: "Grade 5"
    },
    {
      title : "නත්ත​ල",
      image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/pahan.jpg',
      name: "Pahan Bandara",
      school: "Ihala Halmillewa Prathamika Vidyalaya",
      grade: "Grade 5"
    },
    {
      title : "වෙසක් උත්සවය",
      image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/7',
      name: "Kiruli Malinsa",
      school: "Wp/Jaya/Vidyakara B Vidyalaya",
      grade: "Grade 5"
    },
    // {
    //   title: "කොරෝනා වයිරසය පරද​​වමු",
    //   image: 'https://grade5bkt.s3-ap-southeast-1.amazonaws.com/arts/1.jpg',
    //   name: "Dewmi chenara perera. ",
    //   school: "Highlands college, Maharagama",
    //   grade: "Grade 5"
    // }


  ];

  ngOnInit() {

    this.getStaff();
    this.setClass();
    this.getPartners();

  }


  getStaff() {
    this.httpClientService.get(ApiEndpoints.getStaff).subscribe(response => {
      this.members = response as User[];
    }, error => {
      this.ErrorManagerService.setError(error);
    });
  }

  setClass() {
    if (this.router.url == '/aboutus') {
      document.getElementById('about-us').className = 'about-us-landing';
    }
  }

  getPartners() {
    this.commonService.getPartners().then((response: any) => {
      this.aboutUs = response;
    });
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/staff/staff.component.ts